<div class="layout-row align-end gap-2px responsive-column container m-b-20">
  <div #buttonDashboard class="in-block">
    <button mat-raised-button color="primary" [routerLink]="['/dashboard']">
      <fa-icon icon="tachometer-alt" class="m-r-10"></fa-icon>
      {{ "labels.buttons.Dashboard" | translate }}
    </button>
  </div>
</div>

<div class="container">
  <!-- Welcome banner: same animated brand gradient as the login panel -->
  <section class="welcome-banner">
    <img
      src="assets/images/banknbox-icon.svg"
      alt=""
      class="welcome-banner__icon"
    />
    <h1 class="welcome-banner__title">
      {{ "labels.text.Welcome" | translate }}, {{ username }}!
    </h1>
  </section>

  <mat-card>
    <mat-card-content #searchActivity>
      <div class="layout-column">
        <mat-form-field>
          <mat-label>{{
            "labels.placeholders.Search Activity" | translate
          }}</mat-label>
          <input
            matInput
            [matAutocomplete]="activitySearch"
            [formControl]="searchText"
          />
        </mat-form-field>
      </div>

      <mat-autocomplete #activitySearch="matAutocomplete">
        @for (activity of filteredActivities | async; track activity) {
          <mat-option [routerLink]="activity.path">
            <span>{{ activity.activity }}</span>
          </mat-option>
        }
      </mat-autocomplete>
    </mat-card-content>
  </mat-card>
</div>

<ng-template
  #popoverButtons
  let-popover="popover"
  let-prev="prev"
  let-next="next"
>
  <div class="layout-row align-end gap-2px responsive-column">
    <button
      mat-raised-button
      color="warn"
      (click)="popover.close(); configurationWizardService.closeConfigWizard()"
    >
      {{ "labels.buttons.Close" | translate }}
    </button>
    @if (prev) {
      <button
        mat-raised-button
        color="primary"
        (click)="
          popover.close();
          showPopover(prev.template, prev.target, 'bottom', true)
        "
      >
        {{ "labels.buttons.Back" | translate }}
      </button>
    }
    @if (next) {
      <button
        mat-raised-button
        color="primary"
        (click)="
          popover.close();
          showPopover(next.template, next.target, 'bottom', true)
        "
      >
        {{ "labels.buttons.Next" | translate }}
      </button>
    }
  </div>
</ng-template>

<ng-template #templateButtonDashboard let-popover="popover">
  <h2>{{ "labels.heading.Dashboard" | translate }}</h2>
  <p class="mw300">
    {{
      "labels.text.This will navigate the user to the dashboard component."
        | translate
    }}
  </p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button
      mat-raised-button
      color="warn"
      (click)="popover.close(); configurationWizardService.closeConfigWizard()"
    >
      {{ "labels.buttons.Close" | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="popover.close(); previousStep()"
    >
      {{ "labels.buttons.Back" | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="
        popover.close();
        showPopover(templateSearchActivity, searchActivity, 'top', true)
      "
    >
      {{ "labels.buttons.Next" | translate }}
    </button>
  </div>
</ng-template>

<ng-template #templateSearchActivity let-popover="popover">
  <h2>{{ "labels.heading.Search Activity" | translate }}</h2>
  <p class="mw300">
    {{
      "labels.text.This will navigate the user to the searched activity."
        | translate
    }}
  </p>
  <div class="layout-row align-end gap-2px responsive-column">
    <button
      mat-raised-button
      color="warn"
      (click)="popover.close(); configurationWizardService.closeConfigWizard()"
    >
      {{ "labels.buttons.Close" | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="
        popover.close();
        showPopover(templateButtonDashboard, buttonDashboard, 'bottom', true)
      "
    >
      {{ "labels.buttons.Back" | translate }}
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="popover.close(); nextStep()"
    >
      {{ "labels.buttons.Next" | translate }}
    </button>
  </div>
</ng-template>
